var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2de5f672602cc548f967e7964eaaa85b47afde3f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webflow-js@sharesy"]={id:"2de5f672602cc548f967e7964eaaa85b47afde3f"};
      